// Conteúdo fixo do site (o que não é texto traduzível): ficheiros para descarregar, páginas da BD, imagens.
// Os ficheiros vivem em public/ e são copiados do jogo por tools/build_site_assets.py.
import { SITE_DOWNLOADS, type DownloadKey } from "@ecliptica/config/site-sections";
import type { Lang } from "@ecliptica/i18n";

export type { DownloadKey };

/** Ficheiros para descarregar: a tabela vive em @ecliptica/config/site-sections (o backend usa-a para saber a que parte pertence cada um). */
export const DOWNLOADS: Record<Lang, Record<DownloadKey, string>> = SITE_DOWNLOADS;

/** Páginas de amostra do Capítulo 1 da BD. */
export const COMIC_PAGES = [1, 3, 7, 9, 14, 21, 24];
export const comicPage = (lang: Lang, n: number) => `/bd/${lang}/p${String(n).padStart(2, "0")}.webp`;

/** Ilustrações sem moldura (fações, capa do livro). */
export const art = (id: string) => `/art/${id}.webp`;

export const HERO_CARDS = ["ECO-011", "ALV-016", "ECO-028"];
export const FACTION_ART = { sol: "ALV-008", lua: "ECO-032", eclipse: "ALV-034" } as const;
